import React from 'react';
import {
  DetailBlock,
  Select,
  ValidateErrorMessage,
  Option,
  ParamTitle,
} from './StyleUserDetailBlock';

function RednderSelectUserData(elem) {
  return (
    <DetailBlock key={elem.name + elem.value}>
      {elem.title && <ParamTitle>{elem.title}</ParamTitle>}
      <Select
        defaultValue={elem.value}
        name={elem.name}
        onChange={elem.changeFunc}
        onFocus={elem.focusFunc}
      >
        {elem.optionsForSelect.map((item) => (
          <Option key={item.id} value={item.id}>
            {item.value}
          </Option>
        ))}
      </Select>
      <ValidateErrorMessage>
        {!elem.isValidate ? elem.validateErrorMessage : ''}
      </ValidateErrorMessage>
    </DetailBlock>
  );
}

export default RednderSelectUserData;



// WEBPACK FOOTER //
// ./src/Components/MenuGenerator/UserDetailBlock/RenderSelectUserData.jsx